const PERMISSION_STATES = new Set(['granted', 'denied', 'default'])

export const runNotificationPermissionFlow = async ({
  notificationApi,
  onResult = () => {},
  onComplete = () => {},
}) => {
  let permission = 'unsupported'

  try {
    if (notificationApi) {
      permission = notificationApi.permission === 'default'
        ? await notificationApi.requestPermission()
        : notificationApi.permission

      if (!PERMISSION_STATES.has(permission)) {
        permission = 'denied'
      }
    }
  } catch {
    permission = 'denied'
  }

  try {
    onResult(permission)
  } finally {
    onComplete()
  }

  return permission
}
